import React from 'react';
import { useMediaQuery } from '@mui/material';

//TODO: refactor this out to use hooks directly

function withMediaQuery(mediaQuery) {
    return function (Component) {

        return React.forwardRef(function WithStyles(props, ref) {

            const fullScreen = useMediaQuery(mediaQuery);

            return (
                <Component
                    forwardedRef={ref}
                    fullScreen={fullScreen}
                    {...props}
                />
            );
        })
    }
}

export default withMediaQuery;
